import React, { Fragment } from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';

// HOOKS
import { useRecordContext } from 'helpers/getRecordData';

// CORE COMPONENTS
import Form from 'core/form/Form';

// PARTS
import StockNumber from 'routers/interface/tools/StockNumber';

// MAIN COMPONENT
const Trades = props => {

  // FORMIK
  const { values: { aryTradeFallout } } = useFormikContext() || {};

  // HOOKS
  const { record: { aryTrade = [] } } = useRecordContext() || {};

  // RENDER
  return aryTrade?.length ? <>
    <Form.Col>
      <big><span className="text-danger">Alert:</span> You are trying to fallout a deal that has a trade. Is the trade
      being returned to the customer?</big>
    </Form.Col>
    {aryTrade.map((t, i) => <Fragment key={i}>
      <Form.YesNo
        label={`Returned Trade ${i + 1} (${t.stock_num}: ${t.vehicle})`}
        name={`aryTradeFallout[${i}].returned_trade`}
        numeric
        required
        {...props}
      />
      {aryTradeFallout?.[i]?.returned_trade?.[0] === '0' ? <>
        <Form.Col>
          <big><span className="text-danger">Alert:</span> Since the trade is not being returned and will be purchased
          by the dealer, please entered the new purchase stock number for this vehicle.</big>
        </Form.Col>
        <StockNumber
          name={`aryTradeFallout[${i}].purchase_trade_stock_num`}
          label="Purchase Stock #"
          required
          {...props}
        />
      </> : null}
    </Fragment>)}
  </> : null;
}

// EXPORT
export default Trades;
